import React from 'react';
import { ModusWcLoader } from '@trimble-oss/moduswebcomponents-react';
import { DaisySize, LoaderColor, LoaderVariant } from '@trimble-oss/moduswebcomponents';

export interface LoaderProps extends React.ComponentProps<typeof ModusWcLoader> {
  /**
   * The color of the loader.
   */
  color?: LoaderColor;
  /**
   * The size of the loader.
   */
  size?: DaisySize;
  /**
   * The variant of the loader.
   */
  variant?: LoaderVariant;
}
// Wrapper component with all types added
export const Loader: React.FC<LoaderProps> = (props) => {
  return <ModusWcLoader {...props} />;
};
